export default function B2cPage () {
  return (
    <div className="h-full"
      id='api'></div>
  );
}
